import React from "react"

import { Helmet } from "react-helmet"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Header from "../components/header"

import Itemlist from '../components/listload'


const IndexPage = () => (
  <Layout>
    <Helmet>
      <script type="module" src="https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js"></script>
    </Helmet>

    <SEO title="TOPCON AR" />

    <Header siteTitle={`TOPCON WEB AR`} />

    <Itemlist url={'./models/list.json'} />



  
  </Layout>
)

export default IndexPage
